/* eslint-disable no-unused-vars */
import { useEffect, memo, useRef } from 'react';
import { Loader, ErrorBoundary } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { creativesActions } from 'store/campaign/creatives';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE, NEW_CAMP_STAB_DEFAULT_TRACKING } from 'constants';
import uuid from 'react-uuid';
import { checkTrackingLinks } from 'utils';
import { IsOnBoardingSection } from './isOnBoarding/IsOnBoardingSection';
import { IsOngoingSection } from './isOngoing/IsOngoingSection';
import { select_creatives_list, getActiveCreativesList } from 'store/selectors';

import { useFacade } from './useFacade';

const EditCampaign = memo(({ environment }) => {
  const dispatch = useDispatch();
  const { creativeList$, selectedCreativeItem$, showLoader$ } = useFacade();
  const activeCreativesList = useSelector(getActiveCreativesList);
  const changeTabActionRef = useRef(null);

  const loadedCreativeAndTrackingData = useSelector(
    (state) => state.creatives.creativeAndTrackingData,
  );

  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );

  const addCreative = () => {
    const newTmpCreativeId = uuid();
    const newCreativeDefaultItem = { ...NEW_CAMP_STAB_DEFAULT_CREATIVE };
    newCreativeDefaultItem.title =
      loadedCreativeAndTrackingData?.app_name_full || loadedCreativeAndTrackingData?.app_name || '';
    newCreativeDefaultItem.creative_id_token = '';
    newCreativeDefaultItem.name = ''; //'loadedCreativeAndTrackingData.app_name';
    newCreativeDefaultItem.isOnBoarding = loadedCreativeAndTrackingData.isOnBoarding;
    newCreativeDefaultItem.image = loadedCreativeAndTrackingData.app_image;
    newCreativeDefaultItem.bn_bannerid = newTmpCreativeId;
    newCreativeDefaultItem.tmp_id = newTmpCreativeId;
    newCreativeDefaultItem.bn_video_url = loadedCreativeAndTrackingData.store_video_url;
    newCreativeDefaultItem.status = 1;
    newCreativeDefaultItem.icon = loadedCreativeAndTrackingData.app_icon;
    newCreativeDefaultItem.icon_media_id = loadedCreativeAndTrackingData.app_icon_media_id;
    newCreativeDefaultItem.image_media_id = loadedCreativeAndTrackingData.app_image_media_id;

    const newTrackingforDefaultItem = { ...NEW_CAMP_STAB_DEFAULT_TRACKING };
    newTrackingforDefaultItem.tmp_id = newTmpCreativeId;
    newTrackingforDefaultItem.bn_bannerid = newTmpCreativeId;

    if (checkTrackingLinks(creativesTracking, activeCreativesList)) {
      newTrackingforDefaultItem.Deep_Link = creativesTracking[0].Deep_Link;
      newTrackingforDefaultItem.Impression_Link = creativesTracking[0].Impression_Link;
      newTrackingforDefaultItem.Tracking_Link = creativesTracking[0].Tracking_Link;
      newTrackingforDefaultItem.VTA_Link = creativesTracking[0].VTA_Link;
    }

    const position = creativeList$.value.length > 3 ? 3 : creativeList$.value.length;

    dispatch(
      creativesActions.addNewCreative({
        newItem: newCreativeDefaultItem,
        position,
      }),
    );

    dispatch(creativesActions.addTrackingDataForCreative(newTrackingforDefaultItem));
    dispatch(creativesActions.changeCreative(newCreativeDefaultItem));
    changeTabActionRef.current.changeTabToDefaultAction();
  };

  const isOnBoarding = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isOnBoarding,
  );

  if (showLoader$.value) {
    return (
      <div style={{ height: 200, display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={1} />
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div id='creativeSectionId'>
        {isOnBoarding ? (
          <IsOnBoardingSection />
        ) : (
          <IsOngoingSection
            changeTabActionRef={changeTabActionRef}
            creativeList$={creativeList$}
            addCreative={addCreative}
            selectedCreativeItem$={selectedCreativeItem$}
            environment={environment}
          />
        )}
      </div>
    </ErrorBoundary>
  );
});

const NewCampaign_empty = memo(({ environment }) => {
  const creativesList = useSelector(select_creatives_list);

  const dispatch = useDispatch();
  useEffect(() => {
    if (creativesList.length === 1) {
      dispatch(creativesActions.changeCreative(creativesList[0]));
    }
  }, [creativesList.length]);

  return <EditCampaign environment={environment} />;
});
NewCampaign_empty.displayName = 'NewCampaign_empty';
EditCampaign.displayName = 'EditCampaign';

const CreativesSectionTabs = { EditCampaign, NewCampaign_empty };

export default CreativesSectionTabs;
